import React from "react";
import { ConfirmModal } from "../ConfirmModal";
import { AddScheduleModalProps } from "./AddScheduleModal.types";

const buildScheduleInfo = (name?: string, time?: string) => {
  if (!name && !time) return undefined;
  return (
    <>
      Current active schedule:{" "}
      {name ? <strong>{name}</strong> : null}
      {name && time ? " • " : null}
      {time}
    </>
  );
};

export const AddScheduleModal = ({
  open,
  isLoading = false,
  currentScheduleName,
  currentScheduleTime,
  onConfirm,
  onCancel,
}: AddScheduleModalProps) => {
  return (
    <ConfirmModal
      open={open}
      isLoading={isLoading}
      title="Add new schedule?"
      description="Adding a new schedule will replace the currently active one. You can update or switch schedules anytime later."
      infoText={buildScheduleInfo(currentScheduleName, currentScheduleTime)}
      onConfirm={onConfirm}
      onCancel={onCancel}
      confirmLabel="Add schedule"
      cancelLabel="Cancel"
      confirmVariant="primary"
    />
  );
};
